<section class="sign-container sign-up-completed-container">
	<img class="sign-in-background" src="../../../assets/img/{{themeService.theme}}/zp-lg-background.png" alt="">
	<section class="navbar-brand">
		<img src="../../assets/img/{{themeService.theme}}/{{themeService.theme == 'bluecoat' ? 'main-logo' : 'scd-logo'}}.png" alt="Company Logo" width="125px" [ngClass]="{'img-theme-nav-bar': themeService.theme == 'life-file'}">
	</section>
	<div class="sign-account" [routerLink]="['/sign-in']">Already have an account? Sign In</div>
	<section class="container" [ngClass]="{'bluecoat-login-card': themeService.theme == 'bluecoat'}">
		<h1 class="serif-title">Please check your email</h1>
		<div class="sign-get-info">
			<p>We've sent an email confirming your account to:</p>
			<p></p>
			<p>If you don't receive the email within a couple minutes, then please check your spam folder.</p>
			<p>
				<a>Resend confirmation email</a>
			</p>
		</div>
		<input type="submit" class="form-control btn btn-primary primary-default-btn" value="About Me"
			   (click)="goto('about-me-edit/'+clientId)">
		<div class="sign-account sign-account-mobile" [routerLink]="['/sign-in']">Already have an account? Sign In</div>
	</section>
</section>
<app-footer></app-footer>
